import { gql } from '@apollo/client';

export const UPDATE_STAGE = gql`
  mutation UpdateStage($id: Int!, $data: CreateStageInput!) {
    updateStage(id: $id, data: $data) {
      id
      name
      programId
      stageTemplateId
      showInteraction
      createdAt
      updatedAt
      statuses {
        id
        name
        priority
      }
      tasks {
        id
        name
        ctaLabel
        creatorAccess
        fieldSchemas {
          id
          name
          type
        }
      }
      taskSettings {
        initialStatuses {
          id
          name
        }
        finalStatus {
          id
          name
        }
      }
    }
  }
`;
